import { columnsAmountValueByOption } from '../constants/columns-amount-options';

const optionByValue = Object.fromEntries(
  Object.entries(columnsAmountValueByOption).map(([option, value]) => [value, option])
);

const getColumnsAmountOptionByValue = (value) => (value && optionByValue[value]) || '';

export default getColumnsAmountOptionByValue;
